// extracted by mini-css-extract-plugin
module.exports = {"baner":"StaticBaner_baner__i0qgg","mobile":"StaticBaner_mobile__G_wy0"};